
const initialState = {
};

export function getVlaPodil(vlaItem) {
    return `${vlaItem.podil_citatel}/${vlaItem.podil_jmenovatel}`;
}

export default function vla(state = initialState, action) {
    switch (action.type) {
        default:
            return state;
    }
}